import { render, staticRenderFns } from "./SvgTextModal.vue?vue&type=template&id=7ae48523&scoped=true"
import script from "./SvgTextModal.vue?vue&type=script&lang=js"
export * from "./SvgTextModal.vue?vue&type=script&lang=js"
import style0 from "./SvgTextModal.vue?vue&type=style&index=0&id=7ae48523&scoped=true&lang=css"
import style1 from "./SvgTextModal.vue?vue&type=style&index=1&id=7ae48523&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae48523",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ae48523')) {
      api.createRecord('7ae48523', component.options)
    } else {
      api.reload('7ae48523', component.options)
    }
    module.hot.accept("./SvgTextModal.vue?vue&type=template&id=7ae48523&scoped=true", function () {
      api.rerender('7ae48523', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/svg-editor/SvgTextModal.vue"
export default component.exports